module.exports = __webpack_public_path__ + "img/check-valid.8fd64a72.svg";